import React from 'react';
import PropTypes from 'prop-types';

const Grid = ({
  children,
}) => (
  <div className="bootstrap-wrapper">
    <div className="container">
      <div className="row">
        {children}
      </div>
    </div>
  </div>
);

Grid.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Grid;
